import isotipo from "@/brand/asteroi-isotipo-green.svg";
import wordmark from "@/brand/asteroi-wordmark-white.svg";

/**
 * ASTEROI white-label lockup: green isotipo (asterisk) + white wordmark + a thin
 * `admin` tag. Brand art lives in the SVGs; the accessible name is carried by the
 * wrapper so screen readers and tests resolve "ASTEROI admin" regardless of art.
 */
export function BrandMark({
  variant = "header",
  tag = "admin",
  spin = false,
}: {
  variant?: "header" | "hero";
  tag?: string | null;
  spin?: boolean;
}) {
  const hero = variant === "hero";
  const markSize = hero ? "h-12 w-12" : "h-8 w-8";
  const wordSize = hero ? "h-7" : "h-[18px]";

  return (
    <span
      className={`inline-flex items-center ${hero ? "gap-3.5" : "gap-2.5"}`}
      aria-label={`ASTEROI ${tag ?? ""}`.trim()}
    >
      <img
        src={isotipo}
        alt=""
        aria-hidden="true"
        className={`${markSize} ${spin ? "spin-slow" : ""}`}
      />
      <img src={wordmark} alt="" aria-hidden="true" className={`${wordSize} w-auto`} />
      {tag && (
        <span
          className={`border-l border-line-strong font-mono uppercase text-faint ${
            hero
              ? "ml-1.5 pl-3 text-xs tracking-[0.22em]"
              : "ml-1 pl-2.5 text-[11px] tracking-[0.2em]"
          }`}
        >
          {tag}
        </span>
      )}
    </span>
  );
}
